<app-landing-toolbar></app-landing-toolbar>
<div class="landing-top-card primary-background">
    <div class="landing-content">
        <h1 class="site-title">Contact Us</h1>
        <h3>If you need to reach us, use the contact form below</h3>
        <p class="blurb-line">
            We are a small team, working part time. We will get back to you as soon as we can, but since this is not
            yet our day jobs, you'll have to give us some time. Expect to hear back from us within 5 business days.
            If you're a Planner-level member, we will make an extra effort to get back to you-- you can expect to
            hear from us in 2 business days.
        </p>
    </div>
</div>
<div class="landing-content flex-container">
    <div class="contact-flex">
        <mat-card class="flex-container">
            <div class="contact-section contact-words">
                <p>
                    If you need anything on the site or with your account, we're here to help you out! Let us know what we
                    can do for you to the right.
                </p>
                <p>
                    If you have an account with us, be sure to use the same email address your account is registered
                    with.
                </p>
                <p class="required-fields">
                    Note: All fields are required
                </p>
            </div>
            <div class="contact-section">
                <form [formGroup]="contactUs" (submit)="onSubmit()">
                    <mat-form-field class="full-width">
                        <mat-label>First Name</mat-label>
                        <input formControlName="firstName" matInput placeholder="First Name" required>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                        <mat-label>Last Name</mat-label>
                        <input formControlName="lastName" matInput placeholder="Last Name" required>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                        <mat-label>Email</mat-label>
                        <input formControlName="email" matInput placeholder="Email" type="email" required>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                        <mat-label>Message</mat-label>
                        <textarea formControlName="message" matInput rows="5" placeholder="Message..."></textarea>
                    </mat-form-field>
                    <button type="submit" mat-raised-button color="accent">Send</button>
                </form>
            </div>
        </mat-card>
    </div>
</div>
